import { isArray } from 'lodash';
import styles from './styles.scss';

export default function Chips({  data, isDeletable = true, customIcon, handleDelete, stylesOverWrites }) {
    if(!data || !data.length) return null;

    function handleOnDelete(item) {
        const newData = data.filter( el => el.value !== item.value);
        handleDelete(newData);
    }

    function getLabel(item) {
        if(item.chipLabel) {
            return item.chipLabel;
        }
        return item.label;
    }
    return (
        <div className={styles.Chips}>
            {
                isArray(data) && data.map((item, index) => (
                    <div data-cy={`Chip-${getLabel(item)}`} style={stylesOverWrites} key={`${index}_chip`}>
                        {customIcon && (<customIcon />)}
                        <span className={styles.textLabel}>{getLabel(item)}</span>
                        <span className={styles.textLabel}>{item.finalLabel}</span>
                        { isDeletable && (<i onClick={() => handleOnDelete(item)} className={styles.CloseChipIcon}>close</i>)}
                    </div>
                ))
            }
        </div>
    );
}